// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* Removed previous CSS animations as they're now handled by Tailwind */\n[data-v-3e1ae32a] .multiselect__tags {\n    background-color: var(--surface-4)\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
